export const CareersMap = {
  CREATE_CAREERS_START: "CREATE_CAREERS_START",
  CREATE_CAREERS_SUCCESS: "CREATE_CAREERS_SUCCESS",
  CREATE_CAREERS_ERROR: "CREATE_CAREERS_ERROR",
  GET_ALL_CAREERS_START: "GET_ALL_CAREERS_START",
  GET_ALL_CAREERS_SUCCESS: "GET_ALL_CAREERS_SUCCESS",
  GET_ALL_CAREERS_ERROR: "GET_ALL_CAREERS_ERROR",
  UPDATE_CAREERS_START: "UPDATE_CAREERS_START",
  UPDATE_CAREERS_SUCCESS: "UPDATE_CAREERS_SUCCESS",
  UPDATE_CAREERS_ERROR: "UPDATE_CAREERS_ERROR",
  DELETE_CAREERS_START: "DELETE_CAREERS_START",
  DELETE_CAREERS_SUCCESS: "DELETE_CAREERS_SUCCESS",
  DELETE_CAREERS_ERROR: "DELETE_CAREERS_ERROR",
  GET_CAREERS_DETAIL_START: "GET_CAREERS_DETAIL_START",
  GET_CAREERS_DETAIL_SUCCESS: "GET_CAREERS_DETAIL_SUCCESS",
  GET_CAREERS_DETAIL_ERROR: "GET_CAREERS_DETAIL_ERROR",
  GET_CAREERS_LIST_START: "GET_CAREERS_LIST_START",
  GET_CAREERS_LIST_SUCCESS: "GET_CAREERS_LIST_SUCCESS",
  GET_CAREERS_LIST_ERROR: "GET_CAREERS_LIST_ERROR",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  REFRESH_CAREERS_LIST: "REFRESH_CAREERS_LIST",
  SET_CAREERS_BATCH_NUMBER: "SET_CAREERS_BATCH_NUMBER",
  GET_WEB_CAREERS_CIYT_LIST_LOADING: "GET_WEB_CAREERS_CIYT_LIST_LOADING",
  GET_WEB_CAREERS_CIYT_LIST_SUCCESS: "GET_WEB_CAREERS_CIYT_LIST_SUCCESS",
  GET_WEB_CAREERS_CIYT_LIST_ERROR: "GET_WEB_CAREERS_CIYT_LIST_ERROR",
  GET_WEBCLUES_CAREERS_LOGS_START: "GET_WEBCLUES_CAREERS_LOGS_START",
  GET_WEBCLUES_CAREERS_LOGS_SUCCESS: "GET_WEBCLUES_CAREERS_LOGS_SUCCESS",
  GET_WEBCLUES_CAREERS_LOGS_ERROR: "GET_WEBCLUES_CAREERS_LOGS_ERROR",
};

export const CareersActions = {
  getAllCareers: (data) => ({
    type: CareersMap.GET_ALL_CAREERS_START,
    payload: data,
  }),
  getAllCareersSuccess: (data) => ({
    type: CareersMap.GET_ALL_CAREERS_SUCCESS,
    payload: data,
  }),
  getAllCareersError: () => ({ type: CareersMap.GET_ALL_CAREERS_ERROR }),

  createCareersStart: () => ({ type: CareersMap.CREATE_CAREERS_START }),
  createCareersSuccess: (data) => ({
    type: CareersMap.CREATE_CAREERS_SUCCESS,
    payload: data,
  }),
  createCareersError: (errors) => ({
    type: CareersMap.CREATE_CAREERS_ERROR,
    payload: { errors },
  }),

  updateCareersStart: () => ({ type: CareersMap.UPDATE_CAREERS_START }),
  updateCareersSuccess: (data) => ({
    type: CareersMap.UPDATE_CAREERS_SUCCESS,
    payload: data,
  }),
  updateCareersError: (errors) => ({
    type: CareersMap.UPDATE_CAREERS_ERROR,
    payload: { errors },
  }),

  deleteCareersStart: () => ({ type: CareersMap.DELETE_CAREERS_START }),
  deleteCareersSuccess: (data) => ({
    type: CareersMap.DELETE_CAREERS_SUCCESS,
    payload: data,
  }),
  deleteCareersError: (errors) => ({
    type: CareersMap.DELETE_CAREERS_ERROR,
    payload: { errors },
  }),

  getCareersDetail: (data) => ({
    type: CareersMap.GET_CAREERS_DETAIL_START,
    payload: data,
  }),
  getCareersDetailSuccess: (data) => ({
    type: CareersMap.GET_CAREERS_DETAIL_SUCCESS,
    payload: data,
  }),
  getCareersDetailError: () => ({ type: CareersMap.GET_CAREERS_DETAIL_ERROR }),

  getCareersListStart: (data) => ({
    type: CareersMap.GET_CAREERS_LIST_START,
    payload: data,
  }),
  getCareersListSuccess: (data) => ({
    type: CareersMap.GET_CAREERS_LIST_SUCCESS,
    payload: data,
  }),
  getCareersListError: () => ({ type: CareersMap.GET_CAREERS_LIST_ERROR }),

  searchTextChange: (data) => ({
    type: CareersMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  refreshCareersList: () => ({ type: CareersMap.REFRESH_CAREERS_LIST }),
  setCareersBatchNumber: (data) => ({
    type: CareersMap.SET_CAREERS_BATCH_NUMBER,
    payload: data,
  }),

  getWebCareersCityList: () => ({
    type: CareersMap.GET_WEB_CAREERS_CIYT_LIST_LOADING,
  }),
  getWebCareersCityListSuccess: (payload) => ({
    type: CareersMap.GET_WEB_CAREERS_CIYT_LIST_SUCCESS,
    payload,
  }),
  getWebCareersCityListError: () => ({
    type: CareersMap.GET_WEB_CAREERS_CIYT_LIST_ERROR,
  }),

  getCareersLogs: () => ({ type: CareersMap.GET_WEBCLUES_CAREERS_LOGS_START }),
  getCareersLogsSuccess: (data) => ({
    type: CareersMap.GET_WEBCLUES_CAREERS_LOGS_SUCCESS,
    payload: data,
  }),
  getCareersLogsError: () => ({
    type: CareersMap.GET_WEBCLUES_CAREERS_LOGS_ERROR,
  }),
};
